import { LOG_IN } from '../../constants/ActionTypes';

export const loginAction = (isLoggedIn) =>  ({
     type: LOG_IN,
     payload: isLoggedIn,
  });
